var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-action',{key:_vm.key,staticClass:"d-flex w-100",attrs:{"block-action":_vm.blockAction},on:{"purchaseChecked":_vm.handlePurchaseChecked}},[_c('v-button',{attrs:{"primary":""}},[_vm._v(_vm._s(_vm.displayText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }